/* eslint-disable prettier/prettier */
// Action Types para Vendas Online com Parceiro

// Listagem e detalhes
export const VENDAS_ONLINE_PARCEIRO_FETCHED = "VENDAS_ONLINE_PARCEIRO_FETCHED";
export const VENDAS_ONLINE_PARCEIRO_DETAIL_FETCHED = "VENDAS_ONLINE_PARCEIRO_DETAIL_FETCHED";
export const VENDAS_ONLINE_PARCEIRO_LOADING = "VENDAS_ONLINE_PARCEIRO_LOADING";
export const VENDAS_ONLINE_PARCEIRO_RESET = "VENDAS_ONLINE_PARCEIRO_RESET";

// Dados relacionados
export const VENDAS_ONLINE_PARCEIRO_PARTNERS_FETCHED = "VENDAS_ONLINE_PARCEIRO_PARTNERS_FETCHED";
export const VENDAS_ONLINE_PARCEIRO_CATEGORIES_FETCHED = "VENDAS_ONLINE_PARCEIRO_CATEGORIES_FETCHED";
export const VENDAS_ONLINE_PARCEIRO_GROUPINGS_FETCHED = "VENDAS_ONLINE_PARCEIRO_GROUPINGS_FETCHED";
export const VENDAS_ONLINE_PARCEIRO_STATIONS_FETCHED = "VENDAS_ONLINE_PARCEIRO_STATIONS_FETCHED";

// Type ID para esta atividade
export const VENDAS_ONLINE_PARCEIRO_TYPE_ID = 22;
